import { all, fork } from 'redux-saga/effects';
import * as appSagas from 'containers/App/store/saga';
import * as headerSagas from 'containers/Header/store/saga';
import * as authenticationSagas from 'containers/Authentication/store/saga';
import * as accountSagas from 'containers/Account/store/saga';
import * as inviteSagas from 'containers/Invite/store/saga';
import * as objectivesSagas from 'containers/Objective/store/saga';
import * as createObjectiveSagas from 'containers/CreateObjective/store/saga';
import * as ObjectiveActivitySagas from 'containers/ObjectiveActivity/store/saga';
import * as DnDSagas from 'containers/Home/store/saga';
import * as UserBoardSagas from 'containers/Userboard/store/saga';

export default function* sagas() {
  yield all([...Object.values(appSagas)].map(fork));
  yield all([...Object.values(headerSagas)].map(fork));
  yield all([...Object.values(authenticationSagas)].map(fork));
  yield all([...Object.values(accountSagas)].map(fork));
  yield all([...Object.values(objectivesSagas)].map(fork));
  yield all([...Object.values(createObjectiveSagas).map(fork)]);
  yield all([...Object.values(ObjectiveActivitySagas).map(fork)]);
  yield all([...Object.values(DnDSagas).map(fork)]);
  yield all([...Object.values(UserBoardSagas).map(fork)]);
  yield all([...Object.values(inviteSagas).map(fork)]);
}
